<template>
  <div
    class="factory-recommend"
    v-if="list && list.length > 0"
  >
    <div class="factory-recommend__header">
      <p class="factory-recommend__title">
        Supplier's Popular Products
      </p>
      <p
        class="factory-recommend__more"
        @click="onViewAll"
      >
        <Icon name="arrow-right-l-2" />
      </p>
    </div>
    <div class="factory-recommend__content">
      <H5FactoryProductItem
        v-for="item of list"
        :key="item.offerId"
        :item="item"
        @click="onItemClick(item)"
      />
    </div>
  </div>
</template>

<script setup>
import { useQuery } from '@tanstack/vue-query'
import { retrieveFactoryTopProduct } from '@/api/factory'
import { formatName, openURLWithChannelQuery, buriedPointUtil } from '@/utils/utils'
import H5FactoryProductItem from '@/views/Factory/components/H5FactoryProductItem.vue'
import { Icon } from '@/components/Icon'

const props = defineProps({
  factoryId: {
    type: String,
    required: true
  }
})
const factoryId = computed(() => props.factoryId)

const router = useRouter()

const { data: list } = useQuery({
  queryKey: ['/appb/alibaba-common/supplier/product/top', factoryId.value],
  queryFn: () => retrieveFactoryTopProduct({
    sellerOpenId: factoryId.value,
    topN: 8
  }),
  enabled: computed(() => factoryId.value !== null),
  refetchOnWindowFocus: false
})
const supplierName = computed(() => list.value[0]?.supplierName ?? '-')

const onViewAll = () => {
  buriedPointUtil({ eventId: 'HPD212', others: { location: 'Detail' } })
  router.push({
    name: 'factory',
    params: {
      name: formatName(supplierName.value),
      id: factoryId.value
    }
  })
}

const onItemClick = (item) => {
  buriedPointUtil({ eventId: 'HPD204', others: { location: 'Detail' } })
  const { href } = router.resolve({
    name: 'offer',
    params: {
      id: item.offerId
    },
    query: {
      key: btoa(item.monthSold)
    }
  })
  openURLWithChannelQuery(href)
}
</script>

<style lang="less" scoped>
.factory-recommend {
  background-color: white;
  padding: 4px 12px 12px 12px;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__title {
    font-family: mon-700;
    font-size: 14px;
    line-height: 24px;
    color: #232323;
  }

  &__more {
    font-family: mon-600;
    line-height: 14px;
    color: #232323;
    text-decoration: underline;
    cursor: pointer;
    transition: all .2s ease-in-out;

    &:hover {
      color: #004F9A;
    }
  }

  &__content {
    margin-top: 12px;
    display: grid;
    grid-template-columns: repeat(5, 156px);
    gap: 16px;
    overflow-x: scroll;
  }
}
</style>
